<template>
  <div
    tabindex="-1"
    class="py-10 overflow-x-hidden fixed z-50 w-screen h-[100vh] inset-0 bg-slate-400 bg-opacity-75 transition-opacity"
    v-if="inputValue">
    <div class="flex justify-center items-center p-4 w-full min-h-screen h-full">
      <Card class="overflow-y-auto max-h-[85vh]" :class="size">
        <div class="flex justify-between pb-2 mb-3" :class="title ? 'border-b-2' : ''" v-if="header">
          <div class="flex gap-3 items-center">
            <IconSolid :icon="icon" xl />
            <p class="font-bold text-lg">{{ title }}</p>
          </div>
          <i class="fa-solid fa-x cursor-pointer" @click="update"></i>
        </div>
        <div>
          <slot></slot>
        </div>
        <div class="flex gap-3 justify-end pt-3 mt-3">
          <slot name="footer" />
        </div>
      </Card>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue'

const emit = defineEmits(['update:modelValue'])
const props = defineProps({
  title: String,
  icon: String,
  modelValue: {
    type: Boolean,
    default: false,
  },
  size: {
    type: String,
    default: 'w-10/12',
  },
  header: {
    type: Boolean,
    default: true,
  },
})

const inputValue = ref(false)

const update = () => {
  inputValue.value = !inputValue.value
  emit('update:modelValue', inputValue.value)
}

onMounted(() => {
  inputValue.value = props.modelValue
})

watch(
  () => props.modelValue,
  (newVal) => {
    if (newVal !== inputValue.value) {
      inputValue.value = newVal
    }
  }
)
</script>
